// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__cqIt6","hero":"SectionTitle_hero__F3adc"};